import api from './api'

export interface RoleInfo {
    code: string
    label: string
    permissions: string[]
    allowed_statuses: string[]
    is_system: boolean
    // «Админ разработки»: не редактируется, ему доступно всё.
    locked: boolean
    sort_order: number
    user_count: number
}

export interface PermissionDef {
    code: string
    label: string
    description: string
}

export interface StatusGroup {
    group: string
    reasons: { code: string; label: string }[]
}

export interface RolesCatalog {
    roles: RoleInfo[]
    permissions: PermissionDef[]
    status_groups: StatusGroup[]
    locked_role: string
    can_edit: boolean
}

// Роли, права и доступ к статусам. Читают все, меняет только «Админ разработки».
export const rolesApi = {
    catalog: () => api.get<RolesCatalog>('/roles/catalog'),

    create: (label: string, copyFrom?: string) =>
        api.post<{ code: string }>('/roles', { label, copy_from: copyFrom || null }),

    update: (code: string, data: { label?: string; sort_order?: number; permissions?: string[]; allowed_statuses?: string[] }) =>
        api.put(`/roles/${code}`, data),

    remove: (code: string) => api.delete(`/roles/${code}`),
}
